fragment AddressFull on Address {
  street
  streetNumber
  city
  state
  zip
  smartFormAddress {
    BUILDING_CODE
    BUILDING_PARCEL_NUMBER_1
    BUILDING_PARCEL_NUMBER_2
    BUILDING_WITH_LIFT
    CADASTRAL_UNIT_CODE
    CADASTRAL_UNIT_NAME
    CITY
    CITY_AREA_1
    CITY_AREA_1_CODE
    CITY_AREA_2
    CITY_AREA_2_CODE
    CITY_AREA_3
    CITY_AREA_3_CODE
    CITY_CODE
    CODE
    CONSCRIPTION_NUMBER
    COORD_JTSK_X
    COORD_JTSK_Y
    COORD_WGS84_LATITUDE
    COORD_WGS84_LONGITUDE
    COUNTRY
    COUNTRY_CODE
    DISTRICT
    DISTRICT_CODE
    FLOOR_AREA
    FORMATTED_ADDRESS_FIRST_LINE
    FORMATTED_ADDRESS_SECOND_LINE
    FORMATTED_ADDRESS_WHOLE
    NUMBER_OF_FLATS
    NUMBER_OF_STOREYS
    PART
    PART_CODE
    POST
    PROVISIONAL_NUMBER
    REGION
    REGION_CODE
    STREET
    STREET_CODE
    STREET_NUMBER
    STREET_NUMBER_CHAR
    WHOLE_NUMBER
    ZIP
  }
}
